import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './styles/BackButton.module.scss';

type BackButtonType = {
  onClick?: React.MouseEventHandler;
};

const BackButton: React.FunctionComponent<BackButtonType> = (props: BackButtonType) => {
  const { t } = useTranslation();
  const { onClick } = props;
  return (
    <a
      href="#"
      className={styles.back}
      onClick={
        onClick
          ? onClick
          : (e): void => {
              e.preventDefault();
              window.history.back();
            }
      }
    >
      {t('common:general.back')}
    </a>
  );
};

export default BackButton;
